import { Network } from '@kattana-io/common';
import NetworkSelectorCore from '../../../NetworkSelector/core';

export interface NetworkSelectorProps {
    network: Network;
    onChangeNetwork: (id: number) => void;
}

const NetworkSelector = ({network, onChangeNetwork}: NetworkSelectorProps) => {
  return <NetworkSelectorCore
    textSize={14}
    textWeight={'600'}
    imageSize={'m'}
    onClickCallback={onChangeNetwork}
    currentNetwork={network}
  />;
};

export default NetworkSelector;